var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$store.state.web3.ready)?_c('md-progress-bar',{staticClass:"loading",attrs:{"md-mode":"indeterminate"}}):_vm._e(),_vm._v(" "),(_vm.$store.state.web3.ready)?_c('p',[_vm._v("\nDAO address: "+_vm._s(_vm.$store.state.web3.dao.address)+" "),_c('br'),_vm._v("\n\nDAO Ether balance: "+_vm._s(_vm.$store.state.web3.dao.balance.div(_vm.$store.state.web3.token.multiplier).toNumber())+" "),_c('br')]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-486fefea","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Assets.vue
// module id = 416
// module chunks = 1